import React, { useEffect, useState } from "react";
import { countriesApi } from "../../../config/countriesApi";
import { Link } from "react-router-dom";
import styles from "./CountriesMain.module.css";

export default function CountriesMain() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const countries = async () => {
      const countries = await countriesApi();

      if (countries.data) {
        const cont = await countries.data.data;
        setData(countries.data.data);
        console.log(countries.data.data)
        setLoading(false);
      } else if (countries.error) {
        console.log(countries.error);
      }
    };
    countries();
  }, []);

  if (loading) {
    return (
      <div className={styles.loader}>
        <div
          className="spinner-border"
          role="status"
          style={{ position: "relative" }}
        ></div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {data.map((value, index) => (
        <Link to={`/countries/${value.name}`} className={styles.name}>
          <div className={styles.containerIn}>
            <img
              src={value.flag}
              alt={value.name}
              className={styles.image}
            />
            <br />
            {value.display_name}
          </div>
        </Link>
      ))}
    </div>
  );
}
